import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import { Skeleton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import { advisorCanonicalMetrics } from "./helpers/advisorStaticData";

const COLUMN_COUNT = 4;

/**
 * Whole page placeholder for the Edit and Duplicate map screens, shown while
 * the interfaces, destination tables, gap rules and the map itself load.
 */
const AdvisorMapFormSkeleton = () => {
  return (
    <Paper sx={{ mt: 2 }}>
      <Box sx={{ padding: "8px 16px" }}>
        <Skeleton width={180} height={40} sx={{ mb: 1 }} />

        <Grid container spacing={2} alignItems="flex-start" sx={{ mb: 1 }}>
          <Grid size={{ xs: 12, md: 9 }}>
            <Stack direction="row" alignItems="flex-start" gap={2}>
              {Array.from({ length: 3 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  height={40}
                  sx={{ flex: 1, borderRadius: 1 }}
                />
              ))}
            </Stack>
          </Grid>
          <Grid
            size={{ xs: 12, md: 3 }}
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Skeleton
              variant="rectangular"
              width={150}
              height={36}
              sx={{ borderRadius: 1 }}
            />
          </Grid>
        </Grid>

        {/* the gap rule note */}
        <Skeleton
          variant="rectangular"
          height={48}
          sx={{ mb: 1, borderRadius: 1 }}
        />
      </Box>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
                <TableCell key={index} align="left">
                  <Skeleton width={110} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* one row per canonical metric, so the height matches the form */}
            {advisorCanonicalMetrics.map((metric) => (
              <TableRow
                key={metric}
                sx={{
                  "& > *": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                    padding: "10px 16px",
                  },
                }}
              >
                {Array.from({ length: COLUMN_COUNT }).map((_, cellIndex) => (
                  <TableCell key={cellIndex} align="left">
                    <Skeleton width={cellIndex === 1 ? 210 : "80%"} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ padding: "8px 16px" }}>
        <Skeleton width={230} height={20} />
      </Box>
    </Paper>
  );
};

export default AdvisorMapFormSkeleton;
